import { render, staticRenderFns } from "./ValidatedAttributeInput.vue?vue&type=template&id=2150a17a"
import script from "./ValidatedAttributeInput.vue?vue&type=script&lang=ts"
export * from "./ValidatedAttributeInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports